module.exports = __webpack_public_path__ + "static/q1-b1997ebab95ed069d8bc71cb8e975120.png";